import { useEffect, useMemo, useState } from 'react'
import { MultiplierSliderCSS } from './MultiplierSliderCSS.styled'
import { useLvgState } from 'hooks/games/lvg/useLvgState'
import { getLeverageButtonsValue } from './util'

const SLIDER_RANGE = { min: 1, max: 1000 }

const logSlider = (position, leverageRange) => {
  const minP = SLIDER_RANGE.min
  const maxP = SLIDER_RANGE.max

  const minV = Math.log(leverageRange.min)
  const maxV = Math.log(leverageRange.max)

  const scale = (maxV - minV) / (maxP - minP)

  if (+position === maxP) return leverageRange.max

  return Math.exp(minV + scale * (position - minP))
}
const logPosition = (value, leverageRange) => {
  const minP = Number(SLIDER_RANGE.min)
  const maxP = Number(SLIDER_RANGE.max)

  if (value === 0) return minP

  const minV = Math.log(leverageRange.min)
  const maxV = Math.log(leverageRange.max)

  const scale = (maxV - minV) / (maxP - minP)
  return (Math.log(value) - minV) / scale + minP
}

export const MultiplierSlider = ({ leverage, setLeverage }) => {
  const [sliderPosition, setSliderPosition] = useState(SLIDER_RANGE.min)

  const { activeAsset } = useLvgState()

  const colorRotation = useMemo(() => (sliderPosition / SLIDER_RANGE.max) * 90, [sliderPosition])

  useEffect(() => {
    if (!activeAsset?.leverageRange) return
    const position = logPosition(leverage, activeAsset.leverageRange)
    setSliderPosition(position)
  }, [leverage, activeAsset?.leverageRange])

  const onSliderChange = (event) => {
    const position = event.target.value
    let leverage = Math.trunc(logSlider(position, activeAsset.leverageRange))
    if (leverage > activeAsset?.leverageRange?.max) leverage = activeAsset?.leverageRange?.max
    if (leverage < activeAsset?.leverageRange?.min) leverage = activeAsset?.leverageRange?.min
    setLeverage(leverage)
    setSliderPosition(position)
  }

  const onButtonClick = (leverage) => {
    setLeverage(leverage)
  }

  const leverageButtonsArray = useMemo(() => {
    const buttonsArray = getLeverageButtonsValue(activeAsset?.leverageRange || {})
    return buttonsArray
  }, [activeAsset?.leverageRange])

  return (
    <MultiplierSliderCSS>
      <div className='multiplier_slider'>
        <input
          className='range_slider leverage_slider'
          style={{
            filter: `hue-rotate(${colorRotation}deg)`,
          }}
          type='range'
          value={sliderPosition}
          min={SLIDER_RANGE.min}
          max={SLIDER_RANGE.max}
          onChange={onSliderChange}
        />
        <div className='value_buttons' style={{ gridTemplate: `1fr / repeat(${leverageButtonsArray.length}, 1fr)` }}>
          {leverageButtonsArray.map((btnVal) => (
            <button onClick={() => onButtonClick(btnVal)}>{btnVal}x</button>
          ))}
        </div>
        <div className='multiplier_slider_labels'>
          <label className='green'>
            <span>Safu</span>
          </label>
          <label className='red'>
            <span>Extreme Baller Pepe</span>
          </label>
        </div>
      </div>
    </MultiplierSliderCSS>
  )
}
